<template>
 <div class="container-lg mt-5"> 
      <div class="row">
        <div class="col-lg-8 col-md-12 col-12">
        <b-skeleton width="80%" ></b-skeleton>
        <b-skeleton width="30%" ></b-skeleton>
        <br>
         <b-skeleton-img no-aspect height="100px" width="70%"></b-skeleton-img>
         <br>
        <b-skeleton width="30%" ></b-skeleton>
        <b-skeleton width="80%" ></b-skeleton>
        <b-skeleton width="90%" ></b-skeleton>
        <b-skeleton width="90%" ></b-skeleton>
        <b-skeleton width="100%" ></b-skeleton>
        <br>
          <b-skeleton width="30%" ></b-skeleton>
          <div class="d-flex align-items-center">
          <b-skeleton type="button" class="m-1"></b-skeleton>
          <b-skeleton type="button" class="m-1"></b-skeleton> 
          <b-skeleton type="button" class="m-1"></b-skeleton>
          </div>
        </div>
        <div class="col-lg-4 col-md-12 col-12">
             <b-skeleton width="50%" ></b-skeleton>
           <b-skeleton-img no-aspect height="200px"></b-skeleton-img>
           <br>
              <b-skeleton width="50%" ></b-skeleton>
             <b-skeleton-img no-aspect height="200px"></b-skeleton-img>
        </div>
      </div>
      <hr>
      <div class="row mt-3 mb-5">
        <div class="col-lg-2 col-md-6 col-6 mb-3">
             <b-skeleton-img no-aspect height="200px"></b-skeleton-img>
        </div>
          <div class="col-lg-2 col-md-6 col-6 mb-3">
             <b-skeleton-img no-aspect height="200px"></b-skeleton-img>
        </div>
          <div class="col-lg-2 col-md-6 col-6 mb-3">
             <b-skeleton-img no-aspect height="200px"></b-skeleton-img>
        </div>
          <div class="col-lg-2 col-md-6 col-6 mb-3">
             <b-skeleton-img no-aspect height="200px"></b-skeleton-img>
        </div>
          <div class="col-lg-2 col-md-6 col-6 mb-3">
             <b-skeleton-img no-aspect height="200px"></b-skeleton-img>
        </div>
          <div class="col-lg-2 col-md-6 col-6 mb-3">
             <b-skeleton-img no-aspect height="200px"></b-skeleton-img>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6 col-md-12 col-12">
              <b-skeleton-img no-aspect height="400px"></b-skeleton-img>
        </div>
        <div class="col-lg-6 col-md-12 col-12">
              <b-skeleton-img no-aspect height="400px"></b-skeleton-img>
        </div>
      </div>
    </div>
  
</template>

<script>
export default {

}
</script>

<style>

</style>